import { AbTestSubjectComponent } from '~contentful/components/ab-test-subject/ab-test-subject.component';
import { ComponentModel } from '~contentful/models/components/component.model';

export class ABTestSubjectModel extends ComponentModel {
    public readonly name: string;
    public readonly trafficFlow: number;
    public readonly subject?: ComponentModel;
    public readonly componentClass = AbTestSubjectComponent;

    public get contextLabel () {
        return this.parent.contextLabel + ' | Case: ' + this.name;
    }

    public get contextValue () {
        return this.parent.contextValue;
    }
}
